import {Search} from 'js-search';
import {Runner} from '../models/runner';
import RunProvider from './run';
import {
    RUNS,
    RUN_FULL,
    RUN_HALF,
    RUN_RELAY,
} from '../models/waypoint';

export default class SearchProvider {
    static instance = null;

    private searches = new Map<number, Map<string, Search>>();

    private fields: Record<string, Array<string|Array<string>>> = {
        [RUN_FULL]: [
            'startNumber',
            'lastName',
            'firstName',
        ],
        [RUN_HALF]: [
            'startNumber',
            'lastName',
            'firstName',
        ],
        [RUN_RELAY]: [
            'startNumber',
            'lastName',
            'firstName',
            'relayName',
            ['runners', '0', 'lastName'],
            ['runners', '0', 'firstName'],
            ['runners', '1', 'lastName'],
            ['runners', '1', 'firstName'],
            ['runners', '2', 'lastName'],
            ['runners', '2', 'firstName'],
            ['runners', '3', 'lastName'],
            ['runners', '3', 'firstName'],
        ],
    };

    private runProvider: RunProvider;

    static getInstance(): SearchProvider {
        if (!this.instance) {
            this.instance = new SearchProvider();
        }

        return this.instance;
    }

    constructor() {
        this.runProvider = RunProvider.getInstance();

        this.runProvider.getYears().forEach((year) => {
            const runs: Map<string, Search> = new Map();

            RUNS.forEach((run: string) => {
                const search = new Search('startNumber');

                this.fields[run].forEach((field) => {
                    search.addIndex(field);
                });

                runs.set(run, search);
            });

            this.searches.set(year, runs);
        });
    }

    static getSearchWordsFromQuery(query: string): Array<string> {
        if (query === '') {
            return [];
        }

        // Einzelne Wörter getrennt nach Kommas und Leerzeichen
        return query
            .replace(/,/g, ' ')
            .toLowerCase()
            .trim()
            .split(/\s+/);
    }

    filterRunners(year: number, query: string, run: string): Array<any> {
        if (query === '') {
            return [];
        }

        if (!this.searches.get(year).get(run)) {
            // eslint-disable-next-line no-console
            console.error(`Search Index for '${run}' not found.`);
            return [];
        }

        return this.searches.get(year).get(run).search(query);
    }

    addRunner(runner: Runner) {
        this.searches.get(runner.year).get(runner.run).addDocument(runner);
    }
}
